import { render } from "./PatientSummariesManagement.vue?vue&type=template&id=3888d51b&scoped=true"
import script from "./PatientSummariesManagement.vue?vue&type=script&lang=js"
export * from "./PatientSummariesManagement.vue?vue&type=script&lang=js"

import "./PatientSummariesManagement.vue?vue&type=style&index=0&id=3888d51b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3888d51b"]])

export default __exports__